<template>
  <LazyHomeCommonLayout>
    <template #content>
      <section id="contact">
        <div class="containerMain">
          <div class="contact">
            <div class="subBanner">
              <div class="banner_img banner_img1"></div>
              <div class="miniTitle">{{ t("category") }}</div>
              <h1 style="font-size: 56px;">{{ t("title") }}</h1>
              <p>{{ t("description") }}</p>
            </div>
            <ul class="selectArea">
              <li v-for="(info, index) in infoDataList" :key="index">
                <div class="tit">
                  {{ t(`form-menu.${info.key}`) }}
                </div>
                <input
                    :value="info.value"
                    :class="{error: info.isNullCheck}"
                    type="text"
                    :placeholder="t(`place-holder.${info.key}`)"
                    @change="(event) => onChangeInput(event, info.key)"
                >
                <p v-if="info.isNullCheck" class="errorMessage">
                  <span class="icon"></span>{{ t(`error-message.${info.key}`) }}
                </p>
              </li>
              <li>
                <button class="btn blackBtn" @click.stop="onClickSubmitContactInfo">{{ t("button") }}</button>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </template>
  </LazyHomeCommonLayout>
</template>

<i18n>
{
  "en": {
    "category": "Apply",
    "title": "The SW developer You've been looking for, meet them on CodePresso",
    "description": "This survey is designed to help hiring managers effectively assess a developer's practical skills. If you have any suggestions or questions regarding the survey or evaluation, please include them in your response, and we will get back to you through the contact information provided",
    "form-menu": {
      "company-name": "Company Name",
      "manager-name": "Manager Name",
      "company-contact-info": "Company Contact",
      "full-name": "Applicant Name",
      "applicant-contact-info": "Applicant Contact",
      "job-position": "Job Position",
      "job-description": "Job Description",
      "test-date": "Test Date"
    },
    "place-holder": {
      "company-name": "Fill in a company name.",
      "manager-name": "Fill in a manager Name.",
      "company-contact-info": "Fill in a company contact.",
      "full-name": "Fill in a applicant name.",
      "applicant-contact-info": "Fill in a applicant contact.",
      "job-position": "Fill in a job position.",
      "job-description": "Fill in a job description.",
      "test-date": "Fill in a test Date."
    },
    "error-message": {
      "company-name": "You must enter a company name.",
      "manager-name": "You must enter a manager Name.",
      "company-contact-info": "You must enter a company contact.",
      "full-name": "You must enter a applicant name.",
      "applicant-contact-info": "You must enter a applicant contact.",
      "job-position": "You must enter a job position.",
      "job-description": "You must enter a job description.",
      "test-date": "You must enter a test Date."
    },
    "popup": {
      "success": {
        "title": "Your application is now complete.",
        "contents": ""
      }
    },
    "button": "Apply"
  },
  "ko": {
    "category": "신청",
    "title": "당신이 찾던 SW 개발자, 코드프레소에서 만나요.",
    "description": "이 설문은 채용 담당자가 개발자의 실무 역량을 효과적으로 평가할 수 있도록 설계되었습니다. 설문(신청페이지) 또는 평가와 관련하여 제안이나 질문이 있으신 경우 응답에 포함해 주시면 작성하신 연락처를 통해 답변 드리겠습니다.",
    "form-menu": {
      "company-name": "회사명",
      "manager-name": "담당자명",
      "company-contact-info": "회사 연락처",
      "full-name": "지원자 이름",
      "applicant-contact-info": "지원자 연락처",
      "job-position": "직무",
      "job-description": "업무 내용",
      "test-date": "시험 일자"
    },
    "place-holder": {
      "company-name": "회사명을 입력해주세요.",
      "manager-name": "담당자명을 입력해주세요.",
      "company-contact-info": "회사 연락처을 입력해주세요.",
      "full-name": "지원자 이름을 입력해주세요.",
      "applicant-contact-info": "지원자 연락처을 입력해주세요.",
      "job-position": "직무을 입력해주세요.",
      "job-description": "업무 내용을 입력해주세요.",
      "test-date": "시험 일자을 입력해주세요."
    },
    "error-message": {
      "company-name": "회사명을 입력해야 합니다.",
      "manager-name": "담당자명을 입력해야 합니다.",
      "company-contact-info": "회사 연락처을 입력해야 합니다.",
      "full-name": "지원자 이름을 입력해야 합니다.",
      "applicant-contact-info": "지원자 연락처을 입력해야 합니다.",
      "job-position": "직무을 입력해야 합니다.",
      "job-description": "업무 내용을 입력해야 합니다.",
      "test-date": "시험 일자을 입력해야 합니다."
    },
    "popup": {
      "success": {
        "title": "신청이 완료되었습니다.",
        "contents": ""
      }
    },
    "button": "신청"
  },
  "vi": {
    "category": "Đăng ký",
    "title": "Nhà phần mềm SW Bạn đang tìm kiếm Hãy gặp họ ở Codepresso",
    "description": "Khảo sát này được thiết kế nhằm giúp các nhà tuyển dụng đánh giá hiệu quả các kỹ năng thực tế của các nhà phần mềm. Nếu có bất kỳ thắc mắc hay đề xuất liên quan đến khảo sát hoặc đánh giá, vui lòng thêm vào phần trả lời của bạn, chúng tôi sẽ phản hồi lại thông qua thông tin liên hệ đã được cung cấp.",
    "form-menu": {
      "company-name": "Tên công ty",
      "manager-name": "Tên người quản lý",
      "company-contact-info": "Thông tin liên hệ của công ty",
      "full-name": "Tên người nộp đơn",
      "applicant-contact-info": "Thông tin liên hệ của người nộp đơn",
      "job-position": "Chức danh",
      "job-description": "Mô tả công việc",
      "test-date": "Ngày thi"
    },
    "place-holder": {
      "company-name": "Hãy nhập tên công ty.",
      "manager-name": "Hãy nhập tên người quản lý.",
      "company-contact-info": "Hãy nhập thông tin liên hệ của công ty.",
      "full-name": "Hãy nhập tên người nộp đơn.",
      "applicant-contact-info": "Hãy nhập thông tin liên hệ của người nộp đơn.",
      "job-position": "Hãy nhập chức danh của bạn.",
      "job-description": "Hãy nhập mô tả công việc.",
      "test-date": "Hãy nhập ngày thi."
    },
    "error-message": {
      "company-name": "Bạn phải nhập tên công ty.",
      "manager-name": "Bạn phải nhập tên người quản lý.",
      "company-contact-info": "Bạn phải nhập thông tin liên hệ của công ty.",
      "full-name": "Bạn phải nhập tên người nộp đơn.",
      "applicant-contact-info": "Bạn phải nhập thông tin liên hệ của người nộp đơn.",
      "job-position": "Bạn phải nhập chức danh của bạn.",
      "job-description": "Bạn phải nhập mô tả công việc.",
      "test-date": "Bạn phải nhập ngày thi."
    },
    "popup": {
      "success": {
        "title": "Đơn đăng ký của bạn đã hoàn thành.",
        "contents": ""
      }
    },
    "button": "Đăng ký"
  }
}
</i18n>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';
import {emailValidation} from '#imports';
import { useGenericDialog } from '~/composables/useGenericDialog';
import {useContactService} from '~/composables/service/useContactService';
import {IsNullCheckRecruitmentInfo, RecruitmentModel} from '~~/package/mapper/contact/model/RecruitmentModel';

const {t} = useI18n({useScope: 'local'})

const router = useRouter();
const { openGenericAlert } = useGenericDialog();
const contactService = useContactService();
const recruitmentInfo = ref<RecruitmentModel>(new RecruitmentModel());
const isNullCheck = ref<IsNullCheckRecruitmentInfo>(new IsNullCheckRecruitmentInfo());

const infoDataList = computed(() => {
  return [
    {key: "company-name", value: recruitmentInfo.value.companyName, isNullCheck: isNullCheck.value.companyName},
    {key: "manager-name", value: recruitmentInfo.value.managerName, isNullCheck: isNullCheck.value.managerName},
    {key: "company-contact-info", value: recruitmentInfo.value.companyContactInfo, isNullCheck: isNullCheck.value.companyContactInfo},
    {key: "full-name", value: recruitmentInfo.value.fullName, isNullCheck: isNullCheck.value.fullName},
    {key: "applicant-contact-info", value: recruitmentInfo.value.applicantContactInfo, isNullCheck: isNullCheck.value.applicantContactInfo},
    {key: "job-position", value: recruitmentInfo.value.jobPosition, isNullCheck: isNullCheck.value.jobPosition},
    {key: "job-description", value: recruitmentInfo.value.jobDescription, isNullCheck: isNullCheck.value.jobDescription},
    {key: "test-date", value: recruitmentInfo.value.testDate, isNullCheck: isNullCheck.value.testDate}
  ]
})

const onChangeInput = (event: Event, key: string) => {
  if(key === "company-name") recruitmentInfo.value.companyName = (event.target as HTMLInputElement).value
  else if(key === "manager-name") recruitmentInfo.value.managerName = (event.target as HTMLInputElement).value
  else if(key === "company-contact-info") recruitmentInfo.value.companyContactInfo = (event.target as HTMLInputElement).value
  else if(key === "full-name") recruitmentInfo.value.fullName = (event.target as HTMLInputElement).value
  else if(key === "applicant-contact-info") recruitmentInfo.value.applicantContactInfo = (event.target as HTMLInputElement).value
  else if(key === "job-position") recruitmentInfo.value.jobPosition = (event.target as HTMLInputElement).value
  else if(key === "job-description") recruitmentInfo.value.jobDescription = (event.target as HTMLInputElement).value
  else if(key === "test-date") recruitmentInfo.value.testDate = (event.target as HTMLInputElement).value
}


const isValidEmail = computed(() => {
  return emailValidation(recruitmentInfo.value.businessEmail);
});

const onClickSubmitContactInfo = () => {
  if(isMustInquiryInfoDataEmpty()){
    sendEmail(true);
  }
};

const sendEmail = (inquireType: boolean) => {
  contactService.submitContactData(recruitmentInfo.value).then(isSuccess => {
    openApplyAlert(isSuccess)
  })
};

const isMustInquiryInfoDataEmpty = () => {
  if (recruitmentInfo.value.companyName?.length === 0) {
    isNullCheck.value.companyName = true;
    return;
  } else isNullCheck.value.companyName = false;

  if (recruitmentInfo.value.managerName?.length === 0) {
    isNullCheck.value.managerName = true;
    return;
  } else isNullCheck.value.managerName = false;

  if (recruitmentInfo.value.companyContactInfo?.length === 0) {
    isNullCheck.value.companyContactInfo = true;
    return;
  } else isNullCheck.value.companyContactInfo = false;

  if (recruitmentInfo.value.fullName?.length === 0) {
    isNullCheck.value.fullName = true;
    return;
  } else isNullCheck.value.fullName = false;

  if (recruitmentInfo.value.applicantContactInfo?.length === 0) {
    isNullCheck.value.applicantContactInfo = true;
    return;
  } else isNullCheck.value.applicantContactInfo = false;

  if (recruitmentInfo.value.jobPosition?.length === 0) {
    isNullCheck.value.jobPosition = true;
    return;
  } else isNullCheck.value.jobPosition = false;

  if (recruitmentInfo.value.jobDescription?.length === 0) {
    isNullCheck.value.jobDescription = true;
    return;
  } else isNullCheck.value.jobDescription = false;

  if (recruitmentInfo.value.testDate?.length === 0) {
    isNullCheck.value.testDate = true;
    return;
  } else isNullCheck.value.testDate = false;

  return true;
}

const openApplyAlert = (isSuccess: boolean) => {
  if(isSuccess){
    openGenericAlert(
      { title: t("popup.success.title"), contents: t("popup.success.contents") },
      { confirm: { title: t("common-ok"), event: () => { router.replace("/"); } } }
    );
  }
  else {
    openGenericAlert(
      { title: t("common-wrong-approach-title"), contents: t("common-wrong-approach-content") + " support@codepresso.io." },
      { confirm: { title: t("common-ok"), event: () => {} } }
    );
  }
};
</script>
